export default {
  common: {
    account: 'Account',
    agents: 'Agents',
    all: 'All',
    available: 'Available',
    cancel: 'Cancel',
    cloud: 'Cloud',
    copy: 'Copy',
    current: 'current',
    delete: 'Delete',
    error: 'Error',
    export: 'Export',
    help: 'Help',
    home: 'Home',
    language: 'Language',
    links: 'Links',
    loading: 'loading',
    local: 'Local',
    login: 'Login',
    logout: 'Logout',
    metadata: 'Metadata',
    more: 'More',
    name: 'Name',
    never: 'Never',
    none: 'none',
    notes: 'Notes',
    ok: 'Ok',
    open: 'Open',
    password: 'password',
    project: 'project',
    projects: 'Projects',
    publicLink: 'Public link',
    register: 'Register',
    remove: 'Remove',
    save: 'Save',
    search: 'Search',
    settings: 'Settings',
    subscribe: 'Subscribe',
    track: 'track',
    tracks: 'Tracks',
    unknown: 'Unknown',
    unknownArtist: 'Unknown Artist',
    upload: 'Upload',
    username: 'username'
  },
  errors: {
    genericTitle: 'Something went wrong',
    genericDescription: 'Please try again. If it keeps happening, contact support.',
    status: {
      400: 'Some data looks incorrect. Check the form and try again.',
      401: 'Please sign in and try again.',
      403: 'You do not have access to this item.',
      404: 'This item was not found or is no longer available.',
      409: 'This item was changed elsewhere. Refresh the page and try again.',
      413: 'The file is too large or your cloud storage is full.',
      429: 'Too many attempts. Wait a bit and try again.',
      500: 'The server had a problem. Please try again later.',
      502: 'The service is temporarily unavailable. Please try again later.',
      503: 'The service is temporarily unavailable. Please try again later.',
      504: 'The request took too long. Please try again.'
    },
    details: {
      network: 'Check your internet connection and try again.',
      invalidCredentials: 'The e-mail or password is incorrect.',
      invalidToken: 'This sign-in link is invalid or has expired.',
      emailRequired: 'Enter your e-mail and password.',
      invalidEmail: 'Enter a valid e-mail address.',
      invalidPassword: 'Password must be between 3 and 256 characters.',
      userExists: 'An account with this e-mail already exists.',
      storageLimit: 'Your cloud storage is full. Free up space or update your subscription.',
      fileTooLarge: 'This file is too large to upload.',
      trackAlreadyInProject: 'This track is already in the project.',
      trackNotFound: 'This track was not found or is no longer available.',
      projectNotFound: 'This project was not found or is no longer available.',
      linkNotFound: 'This link was not found or has expired.',
      fileNotFound: 'The track file was not found.'
    },
    context: {
      generic: {
        title: 'Something went wrong',
        description: 'Please try again. If it keeps happening, contact support.'
      },
      loadData: {
        title: 'Could not load your library',
        description: 'Local mode was opened instead. Check your connection and try again.'
      },
      loadStandaloneTracks: {
        title: 'Could not load more tracks',
        description: 'Check your connection and try again.'
      },
      loadSingleTrack: {
        title: 'Could not open this track',
        description: 'The track may have been deleted or you may not have access.'
      },
      loadSingleProject: {
        title: 'Could not open this project',
        description: 'The project may have been deleted or you may not have access.'
      },
      search: {
        title: 'Search failed',
        description: 'Check your connection and try again.'
      },
      login: {
        title: 'Could not sign in',
        description: 'Check your e-mail, password, or sign-in link and try again.'
      },
      requestPasswordReset: {
        title: 'Could not send sign-in link',
        description: 'Check the e-mail address and try again.'
      },
      register: {
        title: 'Could not create account',
        description: 'Check the entered details and try again.'
      },
      createTrack: {
        title: 'Could not save track',
        description: 'The track was not saved. Check your connection and try again.'
      },
      updateTrack: {
        title: 'Could not update track',
        description: 'Your changes were not saved. Check your connection and try again.'
      },
      deleteTrack: {
        title: 'Could not delete track',
        description: 'The track is still in your library. Try again.'
      },
      createProject: {
        title: 'Could not create project',
        description: 'The project was not saved. Check your connection and try again.'
      },
      updateProject: {
        title: 'Could not update project',
        description: 'Your changes were not saved. Check your connection and try again.'
      },
      deleteProject: {
        title: 'Could not delete project',
        description: 'The project is still in your library. Try again.'
      },
      reorderProjects: {
        title: 'Could not reorder projects',
        description: 'The order was not saved. Try again.'
      },
      reorderProjectTracks: {
        title: 'Could not reorder tracks',
        description: 'The order was not saved. Try again.'
      },
      getFile: {
        title: 'Could not load file',
        description: 'The file may be missing or temporarily unavailable.'
      },
      uploadFile: {
        title: 'Could not upload file',
        description: 'The file was not uploaded. Check your connection and storage space.'
      },
      deleteCoverImage: {
        title: 'Could not delete cover',
        description: 'The cover was not deleted. Try again.'
      },
      addTrackToProject: {
        title: 'Could not add track to project',
        description: 'The track stayed where it was. Try again.'
      },
      moveTrackToProject: {
        title: 'Could not move track',
        description: 'The track stayed where it was. Try again.'
      },
      removeTrackFromProject: {
        title: 'Could not remove track from project',
        description: 'The track stayed in the project. Try again.'
      },
      saveTrackToLocal: {
        title: 'Could not save track locally',
        description: 'The local copy was not created. Try again.'
      },
      saveTrackToCloud: {
        title: 'Could not save track to cloud',
        description: 'The cloud copy was not created. Check your connection and storage space.'
      },
      createLink: {
        title: 'Could not create public link',
        description: 'The link was not created. Try again.'
      },
      deleteLink: {
        title: 'Could not delete public link',
        description: 'The link is still available. Try again.'
      },
      getLink: {
        title: 'Could not open public link',
        description: 'The link may have expired or been deleted.'
      }
    }
  },
  time: {
    day: 'day',
    days: 'days',
    daysAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'day' : 'days'} ago`
    },
    hoursAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'hour' : 'hours'} ago`
    },
    minutesAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'minute' : 'minutes'} ago`
    },
    rightNow: 'right now',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      const minuteLabel = minutes === 1 ? 'minute' : 'minutes'
      const secondLabel = seconds === 1 ? 'second' : 'seconds'
      if (minutes > 0) return `${minutes} ${minuteLabel} ${seconds} ${secondLabel}`
      return `${seconds} ${secondLabel}`
    }
  },
  topBar: {
    accountFallback: 'Account',
    storage: 'Storage',
    language: 'Language'
  },
  commandPalette: {
    placeholder: 'Search tracks and projects...',
    projects: 'Projects',
    tracks: 'Tracks',
    pages: 'Pages',
    noResults: 'No results found',
    quickLinks: 'Quick Links',
    page: {
      home: 'Home',
      account: 'Account',
      agents: 'Agents',
      links: 'Links',
      settings: 'Settings',
      help: 'Help'
    }
  },
  explorer: {
    searchTitle: 'Search',
    trackCount: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'track' : 'tracks'}`
    }
  },
  emptyState: {
    hello: 'hello',
    addTrack: 'Add a track',
    addTrackSubtitle: 'to get started',
    dragDrop: 'Drag-n-drop',
    dragDropSubtitle: 'your files to upload fast',
    switchStorage: 'Switch',
    switchStorageSubtitle: 'between cloud and local in top menu',
    installAgent: 'Install agent',
    installAgentSubtitle: 'to upload your files automatically',
    playTrack: 'Play a track',
    playTrackSubtitle: 'open bottom player to use effects',
    community: 'have a questions? join or communities on {discord} and {telegram}.'
  },
  create: {
    createProject: 'Create project',
    uploadTrack: 'Upload track',
    newProject: 'New Project',
    artist: 'Artist',
    name: 'Name',
    create: 'Create',
    loading: 'Loading...',
    uploadCover: 'Upload Cover'
  },
  upload: {
    ariaLabel: 'Upload track',
    uploadTrack: 'Upload track',
    analyzing: 'Analyzing...',
    fileAdded: 'File "{name}" added',
    fileReadError: 'File reading error.',
    errorWithMessage: 'Error: {message}'
  },
  dragDrop: {
    dropToUpload: 'Drop to upload',
    deleteDrop: 'Drop here to delete track forever'
  },
  project: {
    upload: 'Upload',
    noTracks: 'No tracks',
    createdBy: 'created by',
    trackSummary: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'track' : 'tracks'}, ${ctx.named('duration')}`
    },
    play: 'Play',
    pause: 'Pause'
  },
  trackItem: {
    more: 'More',
    copyPublicLink: 'Copy public link',
    savedLocally: 'Saved locally',
    saveLocal: 'Save to local storage',
    saving: 'Saving...',
    saveCloud: 'Save to cloud',
    deleteTrack: 'Delete track',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    removeFromProject: 'Remove from {project}',
    moveToProject: 'Move to project',
    currentProject: '(current)',
    confirmDelete: 'Are you sure you want to delete this track?',
    linkCopiedTitle: 'Link copied',
    linkCopiedDescription: 'Public link copied to clipboard'
  },
  trackView: {
    created: 'created {time}',
    tabs: {
      notes: 'Notes',
      metadata: 'Metadata'
    },
    notFound: 'track not found or not available to you',
    untitled: 'Untitled'
  },
  notes: {
    placeholder: 'Add notes about this track...',
    saving: 'Saving...',
    saveError: 'Could not save notes. Please try again.'
  },
  metadata: {
    trackOrder: 'Track Order',
    artist: 'Artist',
    name: 'Name',
    key: 'Key',
    mode: 'Mode',
    deleteTrack: 'Delete track',
    saveError: 'Could not save metadata. Please try again.'
  },
  lufs: {
    momentary: 'Momentary LUFS',
    shortTerm: 'Short-term LUFS',
    integrated: 'Integrated LUFS'
  },
  effects: {
    pitchshift: 'Pitchshift',
    speed: 'Speed',
    balance: 'Balance',
    volume: 'Volume',
    reverberation: 'Reverberation',
    distortion: 'Distortion',
    bitcrush: 'Bitcrush',
    saveCurrentEffectsAs: 'Save current effects as',
    presetName: 'Name',
    add: 'Add',
    availablePresets: 'Available presets',
    tune: 'Tune',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Presets',
    center: 'Center',
    left: 'Left',
    right: 'Right'
  },
  exportPanel: {
    applyEffects: 'Apply current effects',
    applyEffectsSubtitle: 'Export track with current effects applied',
    exportWav: 'Export as WAV',
    exportMp3: 'Export as MP3',
    exporting: 'Exporting...',
    exportAsNewTrack: 'Export as new track',
    creatingTrack: 'Creating track...',
    downloadOriginal: 'Download original',
    originalUnavailable: 'Original file is not available.',
    downloadOriginalFailed: 'Failed to download original file.',
    exportAudioFailed: 'Failed to export track audio.',
    waveformFailed: 'Failed to generate waveform.',
    createTrackFailed: 'Failed to create exported track.',
    createTrackAlert: 'Failed to create exported track: {message}',
    exportedSuffix: ' (export)',
    copySuffix: ' (copy)'
  },
  publicLink: {
    copy: 'Copy',
    open: 'Open',
    linkCopiedTitle: 'Link copied',
    linkCopiedDescription: 'Public link copied to clipboard'
  },
  settings: {
    tabs: {
      settings: 'Settings',
      account: 'Account',
      links: 'Links',
      agents: 'Agents'
    },
    display: 'Display',
    language: 'Language',
    showBpm: 'Show BPM in track view',
    showBpmSubtitle: 'Toggle this setting to show beats per minute for each track in tracklist',
    showLufs: 'Show LUFS in track view',
    showLufsSubtitle: 'Toggle this setting to show loudness units for each track in tracklist',
    showKey: 'Show key in track view',
    showKeySubtitle: 'Toggle this setting to show key and mode for each track in tracklist',
    playback: 'Playback',
    liveLoudness: 'Live loudness metering',
    liveLoudnessSubtitle: 'Toggle this setting to display live loudness meter on player screen',
    persistEffects: 'Keep applied effects for all tracks',
    persistEffectsSubtitle: 'Toggle this setting to keep applied effects on even when track is changed',
    keyboardShortcuts: 'Keyboard shortcuts',
    search: 'Search',
    pressShortcut: 'Press desired key combination',
    storage: 'Storage',
    resetPresetsInfo: 'Reset all presets stored in this browser',
    resetPresets: 'Reset presets',
    resetAllWarning: 'Warning! Button down here delete all data in your local storage!',
    resetAllData: 'Reset all local storage and delete all tracks and projects',
    loadingAccount: 'Loading account...',
    loadingLinks: 'Loading links...',
    loadingAgents: 'Loading agents...',
    authPrompt: 'Log in or register to use this section.',
    loginRegister: 'Log in or register',
    pageTitle: {
      settings: 'settings',
      account: 'account settings',
      links: 'public links',
      agents: 'agents'
    },
    presetsCleared: 'Presets storage cleared',
    localDataDeleted: 'All local data deleted',
    linkCopied: 'Link copied',
    linkCopyFailed: 'Failed to copy link'
  },
  account: {
    hello: 'Hello {name}.',
    subscriptionStatus: 'Your subscription is {status} now',
    noSubscription: 'You have no subscription active.',
    manageSubscription: 'Manage subscription and payment methods',
    subscribeCloud: 'Subscribe to use cloud',
    changeUsername: 'Change Username',
    changePassword: 'Change Password',
    saveUsername: 'Save username',
    savePassword: 'Save password',
    newPassword: 'new password',
    confirmPassword: 'confirm password',
    usernamePlaceholder: 'your username',
    storageUsage: 'Storage usage',
    baseStorage: 'Base Storage',
    subscriptionStorage: 'Subscription Storage',
    used: 'Used',
    available: 'Available',
    deletedFilesNotice: "If you have recently deleted files, they may still be included in these metrics. Don't worry - this will change within a few hours.",
    accountId: 'account id',
    currentPeriodEnds: (ctx) => `current payment period ends in ${ctx.named('count')} ${ctx.named('label')}`,
    accessEnds: (ctx) => `subscription access ends in ${ctx.named('count')} ${ctx.named('label')}`,
    lastPaymentEnded: (ctx) => `last payment period ended on ${ctx.named('date')}`,
    previousBillingDate: 'the previous billing date',
    billingPortalError: 'Billing portal error',
    billingPortalFailed: 'Failed to open billing portal.',
    loginRequiredUpdate: 'You need to be logged in to update your profile.',
    usernameEmpty: 'Username cannot be empty.',
    usernameUnchanged: 'Username is unchanged.',
    usernameUpdated: 'Username updated',
    usernameUpdateFailed: 'Failed to update username. Please try again.',
    passwordEmpty: 'Password cannot be empty.',
    passwordsMismatch: 'Passwords do not match.',
    passwordUpdated: 'Password updated',
    passwordUpdateFailed: 'Failed to update password. Please try again.'
  },
  links: {
    title: 'Public Links',
    description: 'All your public links are listed here - anyone with access to them can listen to the project or track.',
    cloudOnly: 'Public links are only available in Cloud mode. Switch to Cloud storage to create and manage public links.',
    noLinks: 'No public links available',
    createFirst: 'Create your first public link to start sharing.',
    confirmDelete: 'Are you sure you want to delete this link?',
    notFoundTitle: 'Link not found or expired',
    notFoundDescription: 'The link you are trying to access is either invalid or has expired.',
    unknownUser: 'unknown'
  },
  agents: {
    authorizeTitle: 'Authorize Agent',
    authorizeDescription: 'Allow this agent to connect to your account.',
    loginToAuthorize: 'Please log in to authorize this agent.',
    wantsConnect: 'This agent wants to connect to your account to automatically upload audio files.',
    permissionUpload: 'Upload tracks',
    permissionMetadata: 'Create track metadata',
    authorize: 'Authorize',
    cancel: 'Cancel',
    authorizedTitle: 'Agent Authorized',
    authorizedDescription: 'You can now close this window and return to the agent application.',
    desktopTitle: 'Desktop Agent',
    installDescription: 'Install the demoparty agent on your PC or Mac to automatically upload your freshly rendered tracks.',
    warningLabel: 'WARNING: ',
    alphaWarning: 'agent in alpha state and can be unstable.',
    downloadMacApple: 'Download for Mac with Apple Silicon',
    downloadMacIntel: 'Download for Mac with Intel',
    downloadWindows: 'Download for Windows x64',
    signingNotice: 'These builds is not digitally signed because the project is still in development. Security warnings on launch are expected. Signed builds will be provided later.',
    activeTitle: 'Active Agents',
    connectedDescription: 'Agents connected to your account.',
    loginToManage: 'Please log in to manage your agents.',
    noAgents: 'No agents connected yet.',
    lastUsed: 'Last used',
    revoke: 'Revoke',
    remove: 'Remove',
    confirmRemove: 'Are you sure you want to remove this agent?',
    authorizeFailed: 'Failed to authorize agent. Please try again.'
  },
  login: {
    intro: 'You need to log in if you want to use cloud features and subscription benefits. Otherwise, you can use the service locally for free.',
    subscriptionBenefits: 'subscription benefits',
    login: 'Login',
    register: 'Register',
    forgot: 'I forgot my password',
    email: 'e-mail',
    password: 'password',
    repeatPassword: 'repeat password',
    or: 'or',
    google: 'Sign in with Google',
    apple: 'Sign in with Apple',
    resetPassword: 'Reset password',
    resetDescription: 'We will send a sign-in link so you can set a new password.',
    sendResetLink: 'Send reset link',
    invalidToken: 'Invalid or expired token',
    enterEmail: 'Please enter your e-mail',
    resetSent: 'If an account exists, we sent a sign-in link to your e-mail.',
    resetFailed: 'Failed to send reset link. Please try again.'
  },
  googleCallback: {
    wait: 'Please wait, we are logging you in...'
  },
  subscribe: {
    cloudRequiredTitle: 'Cloud storage required',
    cloudRequiredMessage: 'This feature is available only with cloud storage and requires an active subscription.',
    title: 'Start local. Upgrade for auto-upload.',
    description: 'Cloud gives you one synced library across devices.',
    localFree: 'You can use the app for free in local mode.',
    cloudIncludes: 'Cloud includes',
    featureLibrary: 'One synced library across web and iPhone',
    featureAgent: 'Desktop agent auto-upload for fresh renders',
    featureStorage: '100 GB cloud storage for tracks',
    featureLinks: 'Persistent public links for tracks and projects',
    featureTools: 'All local analysis, effects, and export tools included',
    monthly: 'Monthly',
    monthlyDescription: 'Cloud sync, cancel anytime',
    yearly: 'Yearly',
    yearlyDescription: 'Best value for Cloud sync',
    saveTen: 'Save 10%',
    perMonth: '/month',
    billedMonthly: 'Billed monthly',
    billedYearly: '$53.89 billed annually',
    openingCheckout: 'Opening checkout...',
    subscribePlan: 'Subscribe {plan}',
    registerSubscribe: 'Register and subscribe',
    securePayment: 'Secure payment via Polar. Cancel anytime from your account settings.',
    customPlan: 'Need a custom plan or have questions? Contact us at',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    refund: 'Refund Policy',
    checkoutFailed: 'Failed to create checkout. Please try again.'
  },
  thanks: {
    title: 'Thanks for your subscription!',
    description: 'Now you are able to use cloud storage. To manage your subscription please check your account page.',
    startWorking: 'Start working',
    communities: 'Join our communities',
    support: 'If you will have any issues please contact us at {email} or using community links above.'
  },
  help: {
    title: 'Help',
    intro: 'demoparty is a workspace for unfinished music and work-in-progress projects. It allows you to store demos, apply effects, edit tags, and track technical metadata. Local usage is completely free.',
    uploadTitle: 'Upload',
    uploadText: 'You can add a track by clicking the Add button on the main page. During upload, the system automatically detects scale, BPM, and LUFS. Once the upload is complete, you will receive a confirmation notification.',
    storageTitle: 'Storage',
    storageText: 'demoparty provides two storage options: local and cloud.',
    localStorageText: 'Local storage keeps all data only on your device. Tracks and projects are available exclusively in the browser where they were uploaded. IndexedDB is used for storage. No registration is required, and no data is sent anywhere.',
    cloudStorageText: 'Cloud storage keeps your data on demoparty servers. You can access your tracks from anywhere at any time. Registration and an active subscription are required.',
    agentsTitle: 'Agents',
    agentsText: 'When using cloud storage, you can install a desktop agent. The agent automatically uploads newly rendered tracks to the cloud.',
    publicLinksTitle: 'Public links',
    publicLinksText: 'Cloud storage users can create public links to tracks and projects. On the project page, click the link button. For tracks, use the same icon in the track dropdown menu. All generated links can be managed from Settings.',
    exportTitle: 'Export',
    exportText: 'Tracks can be exported with all applied effects. Open the track page and select Export. You can download the original file or export it as MP3 or WAV.',
    supportTitle: 'Support',
    supportText: "For issues related to demoparty cloud subscriptions, contact us at support{'@'}demoparty.app.",
    attributionsTitle: 'Attributions',
    attributionsText: 'The following libraries made this project possible. Credit goes to their respective developers.'
  },
  cover: {
    upload: 'Upload Cover',
    change: 'Change cover',
    delete: 'Delete cover',
    loading: 'Loading...',
    selectImage: 'Please select an image file',
    uploadError: 'Error uploading cover image'
  }
}
